import * as BABYLON from '@babylonjs/core'

const spinAnimLength = .5;
const maxSpinProportion = .25; //Proportion of a full revolution the star makes in the animation.
const scaleAnimLength = .25;
const starScaleBase = .5;
const selectedStarScaleIncrease = .7; //Scale is multiplied by (1 + selectedStarScaleIncrease)

class AnimatedStar {
    spinT = 0;
    scaleT = 0;
    isAnimated = false;

    doDelta(deltaTime, isSelected) {
        if(isSelected && !this.isAnimated) {
            this.startAnimation();
        }

        if(this.isAnimated) {
            this.spinT = Math.min(1, this.spinT + deltaTime / spinAnimLength);
            if(isSelected) {
                this.scaleT = Math.min(1, this.scaleT + deltaTime / scaleAnimLength);
            }
            else
            {
                this.scaleT = Math.max(0, this.scaleT - deltaTime / scaleAnimLength);   
            }
        }

        if(this.isAnimated && !isSelected && this.scaleT == 0 && this.spinT == 1) this.isAnimated = false;
    }

    startAnimation() {
        this.isAnimated = true;
        this.spinT = 0;
        this.scaleT = 0;
    }

    applyTransformToMatrix(mtxIn) {
        const spin = this.#spinFn(this.spinT) * 2 * Math.PI * maxSpinProportion;
        const spinMatrix = BABYLON.Matrix.RotationZ(-spin);

        const starScale = starScaleBase * (1 + selectedStarScaleIncrease * this.scaleT);
        const scaleMatrix = BABYLON.Matrix.Scaling(starScale, starScale, starScale);

        return scaleMatrix.multiply(spinMatrix.multiply(mtxIn));
    }

    //Maps normalized anim time to normalized revolution progress
    #spinFn(t) {
        return -2 * t * t * t + 3 * t * t;
    }
}

export default AnimatedStar;